import { Text } from '@buffer-mono/popcorn'

import { ExpandableEngagementText } from '../../components/ExpandableEngagementText'
import { MentionedChannelText } from '../../components/MentionedChannelText'
import type { MentionedChannel } from '../../util/getMentionedChannelTextParts'
import styles from './MentionText.module.css'

import type { JSX } from 'react'

const NO_CHANNEL: MentionedChannel = {}

type MentionTextProps = {
  text: string
  /**
   * The channel whose own name gets highlighted; omit for no highlight.
   * Spread `MentionedChannelText_Channel` on the channel query.
   */
  channel?: MentionedChannel
}

/**
 * Body text for a mention. Highlights the mentioned channel's own name,
 * with or without a leading `@`, so the eye lands on the "you" reference.
 * @see MentionedChannelText
 */
export const MentionText = ({
  text,
  channel = NO_CHANNEL,
}: MentionTextProps): JSX.Element => (
  <ExpandableEngagementText>
    <Text className={styles.text} translate="no">
      <MentionedChannelText text={text} channel={channel} />
    </Text>
  </ExpandableEngagementText>
)

MentionText.displayName = 'MentionText'
